const ProductGridHorizontal = ({children}) => {
    return (
        // <div className="product-grid-horizontal">
        <div className="product-list" data-type="list">
            {children}
        </div>
    );
};

export default ProductGridHorizontal;